import React, { useEffect } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
// import CKEditorInspector from '@ckeditor/ckeditor5-inspector'
import { string, func, bool, array, object } from 'prop-types'
import { Spin } from 'antd'
import { resizableCkeditorStylesForDocumentDetail } from '../../../../utils/ckeditorStylingDeffaults'

const DocumentTextEditor = ({
	text,
	onUpdateText,
	block,
	versionLoading,
	title,
	ckeditorCss,
	ckeditorStyles,
}) => {
	// inject the ckeditor css into the webpage
	useEffect(() => {
		const composedCss = ckeditorCss + resizableCkeditorStylesForDocumentDetail

		const style = document.createElement('style')
		style.appendChild(document.createTextNode(composedCss))

		document.head.appendChild(style)

		// Clean-up function
		return () => {
			document.head.removeChild(style)
		}
	}, [ckeditorCss])
	return (
		<div
			style={{
				height: '100%',
			}}>
			{versionLoading && (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						background: '#fff',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
					<Spin spinning={versionLoading} />
				</div>
			)}
			<CKEditor
				editor={Editor}
				config={{
					style: ckeditorStyles,
				}}
				onChange={(event, editor) => {
					onUpdateText(editor.getData())
				}}
				data={!versionLoading ? text : ''}
				disabled={block || versionLoading}
			/>
		</div>
	)
}

DocumentTextEditor.propTypes = {
	text: string,
	onUpdateText: func,
	block: bool,
	versionLoading: bool,
	comments: array,
	title: string,
	ckeditorCss: string,
	ckeditorStyles: object,
}

export default DocumentTextEditor
